<igx-circular-bar
  [animate]="false"
  [indeterminate]="true"
  [textVisibility]="false"
  class="pc-loading-spinner"
></igx-circular-bar>
